export default {
  workingSiteRemoved: 'سایت کاری حذف شد',
  workingSiteUpdated: 'سایت کاری به روز رسانی شد',
  workingSiteAdded: 'سایت کاری افزوده شد',
  workingSites: 'سایت های کاری',
  workingSite: 'سایت کاری',
  workingSiteId: 'شناسه سایت کاری',
  fax: 'فکس'
}
